import mixpanel from "mixpanel-browser";

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN!, {
  api_host: "https://api-eu.mixpanel.com",
  persistence: "localStorage",
  track_pageview: false,
  autocapture: false,
  record_sessions_percent: 0,
});

export const analytics = {
  identify(userId: string, properties?: Record<string, any>) {
    mixpanel.identify(userId);
    if (properties) mixpanel.people.set(properties);
  },
  reset() {
    mixpanel.reset();
  },
  track(event: string, properties?: Record<string, any>) {
    mixpanel.track(event, properties);
  },
  pageView(pageName: string, properties?: Record<string, any>) {
    mixpanel.track("page_view", { page: pageName, ...properties });
  },
};
